/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { ptBR } from '@mui/material/locale';
import {
  createTheme,
  ThemeProvider,
  useTheme,
  Box,
  Tooltip,
  Button,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Link, useNavigate } from 'react-router-dom';
import { get } from 'lodash';
import {
  FaEdit,
  FaWindowClose,
  FaExclamation,
  FaCircle,
  FaFilePdf,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import moment from 'moment';
import 'moment/locale/pt-br';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import axios from '../../services/axios';
import Loading from '../../components/Loading';
import NumberFormatCustom from '../../utils/NumberFormatCustom';
import * as colors from '../../config/colors';
import RelatorioDespesas from '../RelatorioDespesas';

const textData = 'Controle de Despesas';
const tableRoute = 'controledespesa';
const tableDatas = 'controledespesas';

export default function Cadastro() {
  const [table, setTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  const [relatorioModalOpen, setRelatorioModalOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  const getData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`/${tableDatas}`);
      setTable(response.data);
    } catch (err) {
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/home`);
    } finally {
      setIsLoading(false);
    }
  }, [navigate]); // Se você estiver usando `navigate` dentro de `getData`, inclua aqui.

  useEffect(() => {
    getData();
  }, [getData]);

  const handleDeleteAsk = (id) => {
    setDeleteConfirmId(id);
  };

  const handleDelete = async (e, id) => {
    e.persist();
    try {
      setIsLoading(true);
      if (id) {
        await axios.put(`/${tableDatas}/${id}`, {
          cancelamento: new Date(),
        });
        setIsLoading(false);
        toast.success('Registro cancelado com sucesso.');
      }
    } catch (err) {
      const status = get(err, 'response.status', 0);
      if (status === 401) {
        toast.error('Você precisa fazer login');
      } else {
        toast.error(`Ocorreu um erro ao cancelar registro.`);
      }
      setIsLoading(false);
    }
    setDeleteConfirmId(null);
    getData();
  };

  /* const handleDelete = async (e, id, index) => {
    e.persist();

    try {
      setIsLoading(true);
      await axios.delete(`/${tableDatas}/${id}`);
      const newTable = [...table];
      newTable.splice(index, 1);
      setTable(newTable);
      setIsLoading(false);
      toast.success('Registro excluido com sucesso.');
    } catch (err) {
      const status = get(err, 'response.status', 0);
      if (status === 401) {
        toast.error('Você precisa fazer login');
      } else if (status === 400) {
        toast.error(
          `Registro não pode ser excluído: Relacionamento entre tabelas.`
        );
      } else {
        toast.error(`Ocorreu um erro ao excluir registro.`);
      }
      setIsLoading(false);
    }
    getData();
  }; */

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
        hidden: true,
      },
      {
        accessorKey: 'lancamento',
        accessorFn: (row) =>
          row.lancamento ? moment(row.lancamento).format('DD/MM/YYYY') : null,
        header: 'Data Lançamento',
        size: 80,
      },
      {
        accessorKey: 'TipoDespesa.nome',
        header: 'Despesa',
        size: 80,
      },
      {
        accessorKey: 'Detalhe.nome',
        header: 'Detalhe',
        size: 80,
      },
      {
        accessorKey: 'valor',
        accessorFn: (row) =>
          row.valor ? (
            <NumberFormatCustom value={row.valor} displayType="text" />
          ) : (
            ''
          ),
        header: 'Valor',
        size: 80,
      },
      {
        accessorKey: 'Favorecido.nome',
        accessorFn: (row) => row.Favorecido?.nome ?? '',
        header: 'Nome Favorecido',
        size: 80,
      },
      {
        accessorKey: 'Funcionario.nome',
        header: 'Nome Funcionário',
        size: 80,
      },
      {
        accessorKey: 'Veiculo.placa',
        accessorFn: (row) => row.Veiculo?.placa || null,
        header: 'Placa',
        size: 80,
      },
      {
        accessorKey: 'Carretum.placa',
        accessorFn: (row) => row.Carretum?.placa || null,
        header: 'Carreta',
        size: 80,
      },
      {
        accessorKey: 'tipo_acao',
        accessorFn: (row) => {
          const actionTypeMap = {
            0: 'Nenhum',
            1: 'Corretiva',
            2: 'Preventiva',
          };
          return actionTypeMap[row.tipo_acao] || 'N/A';
        },
        header: 'Tipo Ação',
        size: 80,
      },
      {
        accessorKey: 'tipo_manutencao',
        header: 'Tipo Manutenção',
        accessorFn: (row) => {
          const actionTypeMap = {
            0: 'Nenhum',
            1: 'Elétrica',
            2: 'Mecênica',
          };
          return actionTypeMap[row.tipo_acao] || 'N/A';
        },
        size: 80,
      },
      {
        accessorKey: 'descricao',
        header: 'Descrição',
        size: 80,
      },
      {
        accessorKey: 'cancelamento',
        accessorFn: (row) =>
          row.cancelamento
            ? moment(row.cancelamento).format('DD/MM/YYYY')
            : null,
        header: 'Data Cancelamento',
        size: 80,
        muiTableHeadCellProps: { sx: { color: 'red' } },
        Cell: ({ renderedCellValue }) => (
          <strong style={{ color: 'red' }}>{renderedCellValue}</strong>
        ),
      },
    ],
    []
  );

  return (
    <ContainerGrid>
      <Loading isLoading={isLoading} />
      <Title>{`${textData}`}</Title>

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          onClick={() => navigate(`/${tableRoute}`)}
        >
          <AddIcon size={24} />
        </Button>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<FaFilePdf />}
          onClick={() => setRelatorioModalOpen(true)}
        >
          Gerar Relatório
        </Button>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginLeft: '5px' }}
          onClick={() => navigate(`/home`)}
        >
          Fechar
        </Button>
      </Box>
      {/* Modal de Relatório */}
      <RelatorioDespesas
        open={relatorioModalOpen}
        onClose={() => setRelatorioModalOpen(false)}
      />
      <ThemeProvider theme={createTheme(theme, ptBR)}>
        <MaterialReactTable
          columns={columns}
          data={table}
          // enableColumnFilterModes
          enableColumnOrdering
          // enableEditing
          // enablePinning
          enableRowActions
          // enableRowSelection
          // enableSelectAll={false}
          initialState={{
            density: 'compact',
            showColumnFilters: false,
            showGlobalFilter: false,
            columnVisibility: { id: false },
          }}
          localization={MRT_Localization_PT_BR}
          renderRowActions={({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Situação">
                <div>
                  {row.getValue('cancelamento') === null ? (
                    <FaCircle size={16} color="#66ff33" />
                  ) : (
                    <FaCircle size={16} color="#FF0000" />
                  )}
                </div>
              </Tooltip>
              <Tooltip arrow placement="left" title="Editar">
                <div>
                  {row.getValue('cancelamento') === null ? (
                    <Link to={`/${tableRoute}/${row.getValue('id')}/edit`}>
                      <FaEdit size={16} />
                    </Link>
                  ) : (
                    <span style={{ opacity: 0.5 }}>
                      <FaEdit size={16} />
                    </span>
                  )}
                </div>
              </Tooltip>
              <Tooltip arrow placement="right" title="Cancelar">
                <div>
                  {row.getValue('cancelamento') === null ? (
                    <div>
                      {deleteConfirmId === row.getValue('id') ? (
                        <FaExclamation
                          size={16}
                          color={colors.errorColor}
                          cursor="pointer"
                          onClick={(e) =>
                            handleDelete(e, row.getValue('id'), row.id)
                          }
                        />
                      ) : (
                        <FaWindowClose
                          size={16}
                          color={colors.primaryColor}
                          cursor="pointer"
                          onClick={() => handleDeleteAsk(row.getValue('id'))}
                        />
                      )}
                    </div>
                  ) : (
                    <span style={{ opacity: 0.5 }}>
                      <FaWindowClose size={16} />
                    </span>
                  )}
                </div>
              </Tooltip>
            </Box>
          )}
        />
      </ThemeProvider>
    </ContainerGrid>
  );
}
